import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "jr-w-full jr-m-auto jr-max-w-login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-center jr-text-black-light jr-text-3.5xl jr-mb-14" }, "パスワードリセット", -1)
const _hoisted_3 = { class: "jr-text-center" }
const _hoisted_4 = { class: "jr-text-center jr-mt-5 jr-text-blue" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ロクイン画面へ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIInputField = _resolveComponent("UIInputField")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "jr-w-full jr-h-screen jr-flex jr-flex-col jr-justify-center jr-items-center",
    autocomplete: "off",
    onSubmit: _ctx.submit
  }, {
    default: _withCtx(({ meta }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_UIInputField, {
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          name: "email-input",
          placeholder: "メールアドレス",
          type: "email",
          rules: "required:メールアドレス|email:メールアドレス",
          class: "jr-block jr-mx-auto jr-w-login jr-mb-14"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UIButton, {
            label: "送信",
            class: "jr-py-4 jr-w-75 jr-border jr-border-blue jr-rounded-md jr-m-auto",
            disabled: !meta.valid,
            primitiveType: "submit",
            onClick: _ctx.handleSubmit
          }, null, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}